export default function AppInitializer() {
    const steps = [];

    return Object.freeze({
        start,
        addStep,
    })

    function addStep({ id, tasks = [] }) {
        steps.push({ id, tasks });
        return this;
    }

    async function start(beforeStart = () => { }) {
        beforeStart();

        for (const step of steps) {
            //console.log('step', step, step.tasks.map(e => e.id))
            await Promise.all(step.tasks.map(e => {
                console.log('app-initializer-executing:\n', e.id);
                const promise = e.execute()
                promise
                    .then(() => {
                        console.log('app-initializer-complete:\n', e.id);
                    })
                    .catch(e => {
                        console.log('app-initializer-failed:\n', e.id, e);
                    })
                return promise;
            }))
        }
    }
}